import React, { useState } from "react"
import { sanityConfig } from "../../sanityConfig"
import GatsbyImage from "gatsby-image"
import { getFluidGatsbyImage } from "gatsby-source-sanity"

const BlockContentFigure = ({
  caption = null,
  imageAssetId,
  alt = "",
  maxWidth = 500,
  isFullWidth = false,
  isGraphicImage = false,
}) => {
  const [isBlurred, setIsBlurred] = useState(true)
  const fluidProps = getFluidGatsbyImage(
    imageAssetId,
    { maxWidth: maxWidth },
    sanityConfig
  )

  const handleClick = (blurValue = true) => {
    return setIsBlurred(blurValue)
  }

  return (
    <figure className="grid w-full justify-items-center my-20 mx-0   ">
      {/* Put caption at top for posters */}
      {caption && isFullWidth && (
        <figcaption className="font-bold text-2xl leading-snug text-center mb-5 uppercase tracking-wide">
          {caption}
        </figcaption>
      )}
      <div
        className={`w-full relative ${isGraphicImage ? "pt-20" : ""} ${
          isFullWidth ? "  max-w-5xl" : "max-w-xl"
        } `}
      >
        <div
          className={`${
            !isBlurred || !isGraphicImage ? "hidden" : ""
          } absolute top-0 left-0 right-0 bottom-0 z-10 grid justify-start items-start`}
        >
          <div className="font-bold grid ">
            <button
              onClick={() => handleClick(false)}
              className="border-2 border-red-500 bg-red-500 text-white hover:bg-white hover:text-red-500 px-4 pt-2 pb-1 rounded justify-self-start  uppercase tracking-wide"
            >
              Display Content
            </button>
            <div className="text-red-500 mt-1 uppercase">
              Warning: Graphic Content
            </div>
          </div>
        </div>
        <div
          className={`${
            isBlurred ? "hidden" : ""
          } absolute top-0 left-0 z-10 grid justify-start items-start`}
        >
          <div className="font-bold opacity-60">
            <button
              onClick={() => handleClick(true)}
              className="border-2 border-red-500 bg-red-500 text-white hover:bg-white hover:text-red-500 px-4 py-1 rounded justify-self-center  uppercase tracking-wide"
            >
              Hide Content
            </button>
          </div>
        </div>
        <GatsbyImage
          fluid={fluidProps}
          alt={alt}
          className={`relative z-0 shadow-md ${
            isBlurred && isGraphicImage ? "filter blur-md" : ""
          }`}
        />
      </div>

      {/* Put caption at bottom for inline images */}

      {caption && !isFullWidth && (
        <figcaption className="font-bold text-2xl text-center mt-3 font-heading">
          {caption}
        </figcaption>
      )}
    </figure>
  )
}

export default BlockContentFigure
